import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/** GET /invites/:code — fetch invite payload by enrollment code. */
export function getInviteByCodeRequest(inviteCode: string): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'invites' },
    op: 'query',
    resourcePath: 'invites',
  };
  return {
    url: `${buildBaseURL(opts)}/${encodeURIComponent(inviteCode)}`,
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
